import { htmlToText } from "html-to-text";

const convertHtmlToText = html => (
  htmlToText(html, {
    wordwrap: 160,
    formatters: {
      // Create a formatter.
      'customFormaterFormatter': function (elem, walk, builder, formatOptions) {
        if(elem.attribs['data-cookiereport']  === 'true') {
          builder.openBlock({ leadingLineBreaks: formatOptions.leadingLineBreaks || 1 });
          walk(elem.children, builder);
          builder.addLineBreak();
          builder.addInline('[Insert the Cookie Declaration table report JavaScript code snippet here]');
          builder.closeBlock({ trailingLineBreaks: formatOptions.trailingLineBreaks || 1 });
        } else {
          builder.openBlock({ leadingLineBreaks: formatOptions.leadingLineBreaks || 1 });
          walk(elem.children, builder);
          builder.closeBlock({ trailingLineBreaks: formatOptions.trailingLineBreaks || 1 });
        }
      }
    },
    tags: {
      'a': { options: { ignoreHref: true } },
      'p': { format: 'customFormaterFormatter' },
    }
  })
);

export {
  convertHtmlToText
}